import { render, staticRenderFns } from "./AnimalAggressiveCell.vue?vue&type=template&id=22eb6998&scoped=true&"
import script from "./AnimalAggressiveCell.vue?vue&type=script&lang=js&"
export * from "./AnimalAggressiveCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22eb6998",
  null
  
)

export default component.exports